// extracted by mini-css-extract-plugin
export default {"button":"CloseBtn_button__CoX66"};